// extracted by mini-css-extract-plugin
module.exports = {"collapse":"HeadlessCollapse_collapse__p2g_e"};